import { auth, type SchemaResponse,unAuth } from "@/modules/api"
import { ECommissionRate, EFilterAffiliate } from "@/modules/helpers/enum"
import { useFilterStore } from "@/modules/helpers/hooks/shared"
import type { Affiliate, AffiliateCampaign, AffiliateCategory } from "@/modules/types"
import type { PagingSchema } from "@/modules/types/common/schema"

type FetchAffiliateExplore = {
  filterBy?: EFilterAffiliate | null
  search?: string
  category?: string
  pageParam?: string | undefined
}

const MAPPING_COMMISSION_RATE = {
  [ECommissionRate.BELOW_3]: {
    // startCommissionRate: null,
    endCommissionRate: 3
  },
  [ECommissionRate.B3_5]: {
    startCommissionRate: 3,
    endCommissionRate: 5
  },
  [ECommissionRate.B5_10]: {
    startCommissionRate: 5,
    endCommissionRate: 10
  },
  [ECommissionRate.B10_15]: {
    startCommissionRate: 10,
    endCommissionRate: 15
  },
  [ECommissionRate.OVER_15]: {
    startCommissionRate: 15
    // endCommissionRate: null,
  }
}

export const getAffiliateExplore = async ({
  filterBy,
  category,
  pageParam,
  ...filters
}: FetchAffiliateExplore) => {
  let params: object = filters

  if (category) {
    params = { category, ...params }
  }
  if (filterBy) {
    params = { filterBy, ...params }
  }

  try {
    const settings: any = useFilterStore.getState().filter

    if (settings) {
      if (settings.commission) {
        const commissionRate =
          MAPPING_COMMISSION_RATE[settings?.commission as keyof typeof MAPPING_COMMISSION_RATE]
        if (commissionRate) params = { ...params, ...commissionRate }
      }

      if (settings.est.select === "over") {
        params = {
          ...params,
          startPrice: 500000,
          endPrice: null
        }
      }
      if (settings.est.select === "all") {
        params = { ...params }
      }
      if (settings.est.select === "rang") {
        params = {
          ...params,
          startPrice: settings.est.rang.startPrice || 1000,
          endPrice: settings.est.rang.endPrice || 500000
        }
      }
    }
  } catch (error) {
    console.log("error", error)
  }

  return auth.get<SchemaResponse<PagingSchema<Affiliate>>>("v1/affiliate/products/list", {
    params: {
      ...params,
      ...(pageParam ? { nextPageToken: pageParam } : {})
    }
  })
}

export const getAffiliateCategories = async () => {
  return auth.get<SchemaResponse<AffiliateCategory>>("affiliate/products/list-categories")
}

export const getAffiliateSearch = async (filters: FetchAffiliateExplore) => {
  const params: object = filters

  return auth.get<SchemaResponse<PagingSchema<Affiliate>>>("affiliate/products/list", {
    params
  })
}

export const getPubicAffiliateSearch = async (filters: FetchAffiliateExplore) => {
  const params: object = filters

  return auth.get<SchemaResponse<PagingSchema<Affiliate>>>("public-api/affiliate/explore", {
    params
  })
}

export const getAffiliateById = (id?: string) => {
  return auth.get<SchemaResponse<Affiliate>>(`affiliate/products/${id}`)
}

export const getAffiliatePreviewById = (id?: string, accessToken?: string) => {
  return unAuth.get<SchemaResponse<Affiliate>>(`affiliate-campaigns/${id}`, {
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  })
}

type FetchAffiliateSimilar = {
  page: number
  take: number
  category?: string
  productId?: string
}
export const getAffiliateSimilar = async (params: FetchAffiliateSimilar) => {
  return unAuth.get<SchemaResponse<PagingSchema<Affiliate>>>(
    "public-api/affiliate/products/similar",
    {
      params
    }
  )
}

export const trackingSaveLink = (productId?: string) => {
  return auth.post<SchemaResponse<Affiliate>>(`affiliate/products/count`, {
    productId: productId?.toString()
  })
}

export const requestProductSample = (data?: {
  address: string
  phoneNumber: string
  fullName: string
  productId: string
}) => {
  return auth.post<SchemaResponse<Affiliate>>(`affiliate/products/request-sample`, data)
}

export const saveAffiliateByProductId = (productId?: string) => {
  return auth.post<SchemaResponse<Affiliate>>(`affiliate/products/save`, {
    productId: productId?.toString()
  })
}
export const unSaveAffiliateByProductId = (productId?: string) => {
  return auth.delete<SchemaResponse<Affiliate>>(`affiliate/products/unsave/${productId}`)
}

type FetchAffiliateSaved = {
  page: number
  take: number
}
export const getAllSaveAffiliates = (params: FetchAffiliateSaved) => {
  return auth.get<SchemaResponse<PagingSchema<Affiliate>>>(`affiliate/products/list-saved`, {
    params
  })
}
export const getAffiliateCampaignDetails = (id?: string) => {
  return auth.get<SchemaResponse<AffiliateCampaign>>(`affiliate-campaigns/${id}`)
}
export const getAffiliateCampaignPreviewDetails = (id?: string, accessToken?: string) => {
  return unAuth.get<SchemaResponse<AffiliateCampaign>>(`affiliate-campaigns/${id}`, {
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  })
}
export const getPublicAffiliateCampaignDetails = (id?: string) => {
  return unAuth.get<SchemaResponse<AffiliateCampaign>>(`public-api/affiliate-campaign/${id}`)
}
